import { createReducer } from 'redux-act';
import {
    signOutUser, toggleExecuteBillingModal,
    toggleSideMenu,
    toggleSideMenuHover,
} from '../actions';

export interface ISettingsReducer {
    showSidebar: boolean;
    showExecuteBillingModal: boolean;
    sidebarHoverState: boolean;
}

const initialState = {
    showSidebar: false,
    showExecuteBillingModal: false,
    sidebarHoverState: false,
};

export const settings = createReducer<ISettingsReducer>({}, initialState);
settings.on(toggleSideMenu, (state: ISettingsReducer) => ({
    ...state,
    showSidebar: !state.showSidebar,
}));
settings.on(toggleSideMenuHover, (state: ISettingsReducer, payload: boolean) => ({
    ...state,
    sidebarHoverState: payload,
}));
settings.on(toggleExecuteBillingModal, (state: ISettingsReducer, payload: boolean) => ({
    ...state,
    showExecuteBillingModal: payload,
}));

settings.on(signOutUser, () => initialState);
